import React from 'react';
import {NavDropdown, Image} from "react-bootstrap";
import {User} from "../../../../model/User";
import {useSelector} from "react-redux";
import {isFree} from "../../../../store/selectors/user/user.selector";
import {Link} from "react-router-dom";


interface LoggedUser {
  loggedUser: User,
}

const SignedUserMenu: React.FC<LoggedUser> = (props) => {
  const isFreeUser = useSelector(isFree)
  return (
    <div className="menu_script_profile">
      {!props.loggedUser.photo && <div className="profile-menu-div">
        <span className="profile-menu">{props.loggedUser.initials}</span>
      </div>}
      {props.loggedUser.photo && <div className="profile-menu-div">
        <Image className="profile-menu-avatar" src={`https://images.tvbizz.net/image_data/${props.loggedUser.photo}`}
               fluid/>
      </div>}
      <NavDropdown title="My Profile" id="collapsible-nav-dropdown" className="profile-position" rootCloseEvent={"click"}>
        <span className="sub-item-indicator"/>
        <div className="profile-nav-dropdown">
          <NavDropdown.Item as={Link} to={"/profile"} className="dropdown_mainmenu profile-dropdown">My TVBIZZ</NavDropdown.Item>
          <NavDropdown.Item as={Link} to={"/profile/subscription"} className="dropdown_mainmenu profile-dropdown">Subscription</NavDropdown.Item>
          {isFreeUser &&
            <NavDropdown.Item as={Link} to={"/profile/upgrade"} className="dropdown_mainmenu profile-dropdown">Upgrade</NavDropdown.Item>}
          <NavDropdown.Item as={Link} to={"/profile/security"} className="dropdown_mainmenu profile-dropdown">Security</NavDropdown.Item>
          <NavDropdown.Item as={Link} to={"/inbox"} className="dropdown_mainmenu profile-dropdown">Inbox</NavDropdown.Item>
          <NavDropdown.Item href="/logout" className="dropdown_mainmenu profile-dropdown">Logout</NavDropdown.Item>
        </div>
      </NavDropdown>
    </div>
  )
}

export default SignedUserMenu;
